<nz-spin [nzSpinning]="productsLoading" class="ShoppingCart-products-container">
  <div *ngIf="isTable" id="shoppingCartsProductsTableContainer" #tableContainer
    [style]="'height:' + this.containerHeight + 'px; overflow: auto; scroll-behavior: smooth;'">
    <nz-table #borderedTable [nzData]="products" [nzFrontPagination]="false" nzBordered="true"
      [nzScroll]="{ y: this.containerHeight - 75 + 'px' }">
      <thead>
        <tr>
          <th *ngFor="let item of TableColumns" [nzWidth]="item.Width == 0 ? 'inherit' : item.Width + 'px'">
            {{ item.Title | locale }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let tableRow of borderedTable.data" [class]="tableRow.RowClass">
          <td *ngFor="let columnName of TableColumns" style="text-align: center">
            <ng-container>
              <img *ngIf="columnName.Name == 'Image'" [src]="tableRow.Image | productImageUrl" class="productImage"
                alt="product" loading="lazy" />
              <span *ngIf="columnName.Name == 'ItemCode'">
                <a (click)="openItemDetails(tableRow[columnName.Name])">
                  {{ tableRow[columnName.Name] }}
                </a>
              </span>
              <span *ngIf="columnName.Name == 'OnHand'">
                {{ tableRow[columnName.Name] }}
              </span>
              <span *ngIf="columnName.Type == 11" class="tableQuantity">
                <button *ngIf="config.UpateQuantityOnKeyboard === 'Y'" nz-button [disabled]="
                    !forceEnableQtyInputs &&
                    (CardCode == null ||
                      CardCode == undefined ||
                      CardCode == '' ||
                      isQuantityDisabled ||
                      tableRow[columnName.Name] <= 0)
                  " (click)="
                    onQuantityChanged(
                      tableRow,
                      +tableRow[columnName.Name] - 1,
                      CardCode,
                      true
                    )
                  ">
                  <i nz-icon nzType="minus" nzTheme="outline"></i>
                </button>
                <input style="
                    width: 63px;
                    height: 34px;
                    border-right: none;
                    text-align: center;
                  " type="text" (keypress)="inputKeyPress($event)" nz-input placeholder="0"
                  [(ngModel)]="tableRow[columnName.Name]" (blur)="
                    config.UpateQuantityOnKeyboard == 'Y'
                      ? onQuantityChanged(
                          tableRow,
                          tableRow[columnName.Name],
                          CardCode
                        )
                      : null
                  " (keyup)="
                    $event.keyCode == 13
                      ? config.UpateQuantityOnKeyboard == 'Y'
                        ? onQuantityChanged(
                            tableRow,
                            tableRow[columnName.Name],
                            CardCode
                          )
                        : null
                      : null
                  " [disabled]="
                    !forceEnableQtyInputs &&
                    (CardCode == null ||
                      CardCode == undefined ||
                      CardCode == '' ||
                      isQuantityDisabled)
                  " />
                <button *ngIf="config.UpateQuantityOnKeyboard === 'Y'" nz-button [disabled]="
                    !forceEnableQtyInputs &&
                    (CardCode == null ||
                      CardCode == undefined ||
                      CardCode == '' ||
                      isQuantityDisabled)
                  " (click)="
                    onQuantityChanged(
                      tableRow,
                      +tableRow[columnName.Name] + 1,
                      CardCode,
                      true
                    )
                  ">
                  <i nz-icon nzType="plus" nzTheme="outline"></i>
                </button>
                <button *ngIf="config.UpateQuantityOnKeyboard !== 'Y'" nz-button [disabled]="
                    !forceEnableQtyInputs &&
                    (CardCode == null ||
                      CardCode == undefined ||
                      CardCode == '' ||
                      isQuantityDisabled)
                  " (click)="
                    onQuantityChanged(
                      tableRow,
                      tableRow[columnName.Name],
                      CardCode,
                      false,
                      true
                    )
                  ">
                  <i class="fas fa-cart-plus"></i>
                </button>
                <button *ngIf="tableRow.VariantEnabled === 'Y'" nz-button [disabled]="
                    !forceEnableQtyInputs &&
                    (CardCode == null ||
                      CardCode == undefined ||
                      CardCode == '' ||
                      isQuantityDisabled)
                  " (click)="
                    variantHandlerEmit(
                      tableRow
                    )
                  ">
                  <i nz-icon nzType="appstore-add" nzTheme="outline"></i>
                </button>
              </span>
              <span *ngIf="columnName.Name == 'FreeQuantity'">
                {{
                tableRow[columnName.Name] == null
                ? 0
                : tableRow[columnName.Name]
                }}
              </span>
              <span *ngIf="columnName.Type == 3">
                <ng-container *ngIf="columnName.Mode == 1">
                  {{ tableRow[columnName.Name] | price : tableRow.Currency }}
                </ng-container>
                <ng-container *ngIf="columnName.Mode != 1">
                  <input nz-input [disabled]="
                      tableRow['D_' + columnName.Name] != null &&
                      tableRow['D_' + columnName.Name] == 0
                        ? true
                        : !itemsInCart.has(tableRow.ItemCode)
                    " [readonly]="
                      tableRow['D_' + columnName.Name] != null &&
                      tableRow['D_' + columnName.Name] == 0
                        ? true
                        : !itemsInCart.has(tableRow.ItemCode)
                    " style="width: 60%" [(ngModel)]="tableRow[columnName.Name]"
                    (blur)="onBlur($event, tableRow, columnName.Name)" />
                </ng-container>
              </span>
              <span *ngIf="columnName.Name == 'Discount'">
                {{ tableRow.Discount != null ? tableRow.Discount : 0 }} %
              </span>
              <span *ngIf="
                  columnName.Name !== 'Discount' &&
                  columnName.Name !== 'FreeQuantity' &&
                  columnName.Name !== 'OnHand' &&
                  columnName.Name !== 'Image' &&
                  columnName.Name !== 'ItemCode' &&
                  columnName.Type != 3 &&
                  columnName.Type != 11 &&
                  columnName.Type != 17 &&
                  columnName.Type != 10
                ">
                <!-- Read Only Fields -->
                <ng-container *ngIf="columnName.Mode == 1 && !columnName.IsHTML">
                  {{ tableRow[columnName.Name] }}
                </ng-container>

                <ng-container *ngIf="columnName.Mode == 1 && columnName.IsHTML">
                  <p [innerHtml]="tableRow[columnName.Name]"></p>
                </ng-container>

                <!-- Editable Fields -->
                <ng-container *ngIf="columnName.Mode != 1">
                  <input *ngIf="columnName.Type !== 2 && columnName.Type !== 7 && columnName.Type !== 4" type="text"
                    nz-input [disabled]="
                      tableRow['D_' + columnName.Name] != null &&
                      tableRow['D_' + columnName.Name] == 0
                        ? true
                        : !itemsInCart.has(tableRow.ItemCode)
                    " [readonly]="
                      tableRow['D_' + columnName.Name] != null &&
                      tableRow['D_' + columnName.Name] == 0
                        ? true
                        : !itemsInCart.has(tableRow.ItemCode)
                    " [(ngModel)]="tableRow[columnName.Name]" (blur)="onBlur($event, tableRow, columnName.Name)" />

                  <input *ngIf="columnName.Type === 4" type="number" nz-input [disabled]="
                      tableRow['D_' + columnName.Name] != null &&
                      tableRow['D_' + columnName.Name] == 0
                        ? true
                        : !itemsInCart.has(tableRow.ItemCode)
                    " [readonly]="
                      tableRow['D_' + columnName.Name] != null &&
                      tableRow['D_' + columnName.Name] == 0
                        ? true
                        : !itemsInCart.has(tableRow.ItemCode)
                    " [(ngModel)]="tableRow[columnName.Name]" (blur)="onBlur($event, tableRow, columnName.Name)" />

                  <nz-select [nzShowSearch]="true" style="width: 75%" [ngClass]="{ unitNeeded: !tableRow['Unit'] }"
                    *ngIf="columnName.Type === 7 && columnName.Name === 'SUomEntry' && columnName.Mode != 1"
                    (nzOpenChange)="getOptions(tableRow, columnName)" [(ngModel)]="tableRow[columnName.Name]"
                    [nzShowArrow]="false" (ngModelChange)="onBlur($event, tableRow, columnName.Name)">
                    <ng-container *ngFor="let option of columnName.Options">
                      <nz-option *ngIf="!isLoading" [nzValue]="option.Code?.toString()"
                        [nzLabel]="option.Name"></nz-option>
                    </ng-container>
                    <nz-option *ngIf="isLoading" nzDisabled nzCustomContent>
                      <i nz-icon nzType="loading" class="loading-icon"></i>
                      {{ "Loading ..." | locale }}
                    </nz-option>
                  </nz-select>

                  <nz-select [nzShowSearch]="true" style="width: 75%"
                    [ngClass]="{ whsNeeded: tableRow['SelectedQuantity'] && !tableRow['WhsName'] }"
                    *ngIf="columnName.Type === 7 && columnName.Name === 'WhsCode' && columnName.Mode != 1"
                    (nzOpenChange)="getOptions(tableRow, columnName)" [(ngModel)]="tableRow[columnName.Name]"
                    [nzShowArrow]="false" (ngModelChange)="onBlur($event, tableRow, columnName.Name)">
                    <ng-container *ngFor="let option of columnName.Options">
                      <nz-option *ngIf="!isLoading" [nzValue]="option.Code?.toString()"
                        [nzLabel]="option.Name"></nz-option>
                    </ng-container>
                    <nz-option *ngIf="isLoading" nzDisabled nzCustomContent>
                      <i nz-icon nzType="loading" class="loading-icon"></i>
                      {{ "Loading ..." | locale }}
                    </nz-option>
                  </nz-select>

                  <nz-select [nzShowSearch]="true" style="width: 75%"
                    *ngIf="columnName.Type === 7 && ((columnName.Name !== 'SUomEntry'  && columnName.Name !== 'WhsCode') || columnName.Mode == 1)"
                    (nzOpenChange)="getOptions(tableRow, columnName)" [(ngModel)]="tableRow[columnName.Name]"
                    [nzShowArrow]="false" (ngModelChange)="onBlur($event, tableRow, columnName.Name)">
                    <ng-container *ngFor="let option of columnName.Options">
                      <nz-option *ngIf="!isLoading" [nzValue]="option.Code?.toString()"
                        [nzLabel]="option.Name"></nz-option>
                    </ng-container>
                    <nz-option *ngIf="isLoading" nzDisabled nzCustomContent>
                      <i nz-icon nzType="loading" class="loading-icon"></i>
                      {{ "Loading ..." | locale }}
                    </nz-option>
                  </nz-select>

                  <nz-date-picker *ngIf="columnName.Type === 2" [ngModelOptions]="{ updateOn: 'blur' }" [disabled]="
                      tableRow['D_' + columnName.Name] != null &&
                      tableRow['D_' + columnName.Name] == 0
                        ? true
                        : !itemsInCart.has(tableRow.ItemCode)
                    " [nzDisabled]="
                      tableRow['D_' + columnName.Name] != null &&
                      tableRow['D_' + columnName.Name] == 0
                        ? true
                        : !itemsInCart.has(tableRow.ItemCode)
                    " [(ngModel)]="tableRow[columnName.Name]"
                    (ngModelChange)="onBlur($event, tableRow, columnName.Name)">
                  </nz-date-picker>
                </ng-container>
              </span>

              <!-- button Fields -->
              <span *ngIf="columnName.Type == 17">
                <button [class]="columnName.Name" (click)="
                  executeLineAction(
                    tableRow,
                    columnName.Name
                  )
                ">
                  {{columnName.Title | locale }}
                </button>
              </span>
              <span *ngIf="columnName.Type == 10 && columnName.Name != 'Image'">
                <img [src]="tableRow[columnName.Name] | productImageUrl" [class]="columnName.Name"
                alt="product" loading="lazy" />
              </span>
            </ng-container>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>
  <div *ngIf="!isTable" id="shoppingCartsProductsCardsContainer" #cardsContainer [style]="
      (containerHeight > 0 ? 'height:' + containerHeight + 'px;' : '') +
      'overflow: auto;scroll-behavior: smooth;'
    ">
    <div nz-row>
      <div nz-col #cartProductCard [class]="'gutter-row cart-product-card ' + tableRow.RowClass" [nzXs]="24" [nzSm]="24"
        [nzMd]="12" [nzLg]="12" [nzXl]="8" *ngFor="let tableRow of products">
        <nz-card class="productCardVertical" [nzCover]="cardVertical === 'Y' ? avatarTemplate : null" [ngClass]="{
            InCart:
              tableRow.SelectedQuantity != 0 &&
              tableRow.SelectedQuantity != null,
            productCardVertical: CardCode != '' && cardVertical == 'Y',
            productCardHorizontal: CardCode != '' && cardVertical != 'Y',
            noBpVertical: CardCode == '' && cardVertical == 'Y',
            noBpHorizontal: CardCode == '' && cardVertical != 'Y'
          }" [style.text-align]="cardVertical === 'Y' ? 'center' : null">
          <ng-template #cardTitle>
            <div *ngIf="tableRow.ItemTemplateHtml; else defaultCardTitle" class="product-card-template"
              [innerHTML]="tableRow.ItemTemplateHtml | safeHtml"></div>
            <ng-template #defaultCardTitle>
              <p class="ant-card-meta-title" [innerHtml]="tableRow.ItemName"></p>
            </ng-template>
          </ng-template>
          <nz-card-meta (click)="openItemDetails(tableRow['ItemCode'])" [nzTitle]="cardTitle" [nzDescription]="cardDesc"
            [nzAvatar]="cardVertical !== 'Y' ? avatarTemplate : null"
            style="display: inline; cursor: pointer"></nz-card-meta>
          <ng-template #cardDesc>
            <ng-container *ngIf="!tableRow.ItemTemplateHtml">
              {{ tableRow.ItemCode }}
              <div>
                <span class="product-card-price">
                  <div *ngIf="tableRow.Unit !== '' && tableRow.Unit !== null">
                    {{ tableRow.Unit }}
                  </div>
                  <div *ngIf="tableRow.WhsName !== '' && tableRow.WhsName !== null">
                    {{ tableRow.WhsName }}
                  </div>
                  <span *ngIf="tableRow.Discount == 0 || !tableRow.Discount">
                    {{ tableRow.Price | price : tableRow.Currency }}
                  </span>
                  <span *ngIf="tableRow.Discount > 0">
                    <del>{{ tableRow.Price | price : tableRow.Currency }}</del>
                    {{ tableRow.PriceAfDis | price : tableRow.Currency }}
                  </span>
                </span>
                <p *ngIf="tableRow['Availability'] != null" [innerHTML]="tableRow['Availability'] | safeHtml"></p>
                <p *ngIf="
                    tableRow['ExtraData'] != null &&
                    tableRow['ExtraData']['Availability'] != null
                  " [innerHTML]="tableRow['ExtraData']['Availability'] | safeHtml"></p>
              </div>
            </ng-container>
          </ng-template>
          <div [class.cardFooter]="cardVertical != 'Y'" *ngIf="CardCode != ''">
            <hr />
            <div class="cardControls">
              <h4 [class.productPrice]="cardVertical !== 'Y'" *ngIf="
                  tableRow.SelectedQuantity && tableRow.SelectedQuantity > 0 && cart !== undefined
                ">
                {{ tableRow.LineTotal | price : cart.DocCurrency }}
              </h4>

              <h4 [class.productPrice]="cardVertical !== 'Y'" *ngIf="
                  tableRow.SelectedQuantity && tableRow.SelectedQuantity > 0 && cart === undefined
                ">
                {{ tableRow.LineTotal | price : tableRow.Currency }}
              </h4>

              <nz-select [nzShowSearch]="true" [ngClass]="{ unitNeeded: !tableRow['Unit'] }"
                style="width: 40%;padding-right: 10px;" *ngIf="uomEditable"
                (nzOpenChange)="getOptions(tableRow, undefined,'SUomEntry')" [(ngModel)]="tableRow['SUomEntry']"
                [nzShowArrow]="false" nzPlaceHolder="Select a UOM"
                (ngModelChange)="onBlur($event, tableRow, 'SUomEntry')">
                <ng-container *ngFor="let option of tableRow.Options">
                  <nz-option *ngIf="!isLoading" [nzValue]="option.Code?.toString()" [nzLabel]="option.Name"></nz-option>
                </ng-container>
                <nz-option *ngIf="isLoading" nzDisabled nzCustomContent>
                  <i nz-icon nzType="loading" class="loading-icon"></i>
                  {{ "Loading ..." | locale }}
                </nz-option>
              </nz-select>

              <nz-select [nzShowSearch]="true"
                [ngClass]="{ whsNeeded:tableRow['SelectedQuantity'] && !tableRow['WhsName'] }"
                style="width: 40%;padding-right: 10px;" *ngIf="whsEditable"
                (nzOpenChange)="getOptions(tableRow, undefined,'WhsCode')" [(ngModel)]="tableRow['WhsCode']"
                [nzShowArrow]="false" nzPlaceHolder="Select a Warehouse"
                (ngModelChange)="onBlur($event, tableRow, 'WhsCode')">
                <ng-container *ngFor="let option of tableRow.Options">
                  <nz-option *ngIf="!isLoading" [nzValue]="option.Code?.toString()" [nzLabel]="option.Name"></nz-option>
                </ng-container>
                <nz-option *ngIf="isLoading" nzDisabled nzCustomContent>
                  <i nz-icon nzType="loading" class="loading-icon"></i>
                  {{ "Loading ..." | locale }}
                </nz-option>
              </nz-select>

              <button *ngIf="config.UpateQuantityOnKeyboard === 'Y'" class="decrease-qty-btn" nz-button [disabled]="
                  !forceEnableQtyInputs &&
                  (CardCode == null ||
                    CardCode == undefined ||
                    CardCode == '' ||
                    isQuantityDisabled)
                " (click)="
                  onQuantityChanged(
                    tableRow,
                    +tableRow.SelectedQuantity - 1,
                    CardCode,
                    true
                  )
                ">
                <i nz-icon nzType="minus" nzTheme="outline"></i>
              </button>
              <input style="
                  width: 63px;
                  height: 34px;
                  border-right: none;
                  text-align: center;
                " type="text" (keypress)="inputKeyPress($event)" nz-input placeholder="0"
                [(ngModel)]="tableRow.SelectedQuantity" (blur)="
                  config.UpateQuantityOnKeyboard == 'Y'
                    ? onQuantityChanged(tableRow, $event.target.value, CardCode)
                    : null
                " [disabled]="
                  !forceEnableQtyInputs &&
                  (CardCode == null ||
                    CardCode == undefined ||
                    CardCode == '' ||
                    isQuantityDisabled)
                " />
              <button *ngIf="config.UpateQuantityOnKeyboard === 'Y'" class="increase-qty-btn" nz-button [disabled]="
                  !forceEnableQtyInputs &&
                  (CardCode == null ||
                    CardCode == undefined ||
                    CardCode == '' ||
                    isQuantityDisabled)
                " (click)="
                  onQuantityChanged(
                    tableRow,
                    +tableRow.SelectedQuantity + 1,
                    CardCode,
                    true
                  )
                ">
                <i nz-icon nzType="plus" nzTheme="outline"></i>
              </button>
              <button *ngIf="config.UpateQuantityOnKeyboard !== 'Y'" nz-button [disabled]="
                  !forceEnableQtyInputs &&
                  (CardCode == null ||
                    CardCode == undefined ||
                    CardCode == '' ||
                    isQuantityDisabled)
                " (click)="
                  onQuantityChanged(
                    tableRow,
                    tableRow.SelectedQuantity,
                    CardCode
                  )
                ">
                <i class="fas fa-cart-plus"></i>
              </button>
            </div>
          </div>

          <nz-tag nzColor="error" *ngIf="tableRow.OnHand <= 0 && tableRow['Availability'] == null"
            [class.outStockTag]="cardVertical != 'Y'">
            <span> {{ "Out of Stock" | locale }}</span>
          </nz-tag>
          <nz-tag nzColor="green" *ngIf="tableRow.OnHand > 0 && tableRow['Availability'] == null"
            [class.inStockTag]="cardVertical != 'Y'">{{ "In Stock" | locale }}</nz-tag>
          <!--<span [innerHTML]="tableRow.ItemTemplateHtml | safeHtml">
          </span> -->

          <div class="cartIcon" *ngIf="
              tableRow.SelectedQuantity != 0 &&
              tableRow.SelectedQuantity != null
            ">
            <div style="position: relative">
              <i class="fas fa-shopping-cart"></i>
            </div>
          </div>
        </nz-card>
        <ng-template #avatarTemplate>
          <div style="width: 100%; padding: 1px" [style.height]="cardVertical == 'Y' ? '300px' : null"
            [style.text-align]="cardVertical == 'Y' ? 'center' : null">
            <img [src]="tableRow.Image | productImageUrl" [class]="
                cardVertical !== 'Y' ? 'productImage' : 'CardProductImage'
              " alt="product" />
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</nz-spin>
<ng-template #nullTemp> </ng-template>

<nz-modal [(nzVisible)]="isTokenModalVisible" nzTitle="Document Link" [nzClosable]="true">
  <div *nzModalContent>
    <input nz-input type="text" [value]="tokenLink" />
  </div>
  <div *nzModalFooter>
    <button nz-button nzType="primary" (click)="copyTokenLink()">
      {{ "Copy" | locale }}
    </button>
    <button nz-button nzType="default" (click)="isTokenModalVisible = false">
      {{ "Close" | locale }}
    </button>
  </div>
</nz-modal>
